/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { Calendar, CalendarDays, CheckCircle, Target, TrendingUp, Trophy, Users } from 'lucide-react';
import React from 'react';
import { TournamentAnalyticsSummary } from '../../domain/interfaces/tournament-analytics';
import KpiCard from './kpi-card';

interface KpiGridProps {
  summary: TournamentAnalyticsSummary | undefined;
  loading: boolean;
}

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const SkeletonCard = styled.div`
  background: ${({ theme }) => theme.colors.SurfaceWhite};
  border: 1px solid ${({ theme }) => theme.colors.SurfacePlatinum20};
  border-radius: 12px;
  padding: 20px 16px;
  height: 108px;
  animation: pulse 1.5s ease-in-out infinite;

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
`;

const ICON_SIZE = 20;

const KpiGrid = React.memo(({ summary, loading }: KpiGridProps) => {
  if (loading || !summary) {
    return (
      <Grid>
        {Array.from({ length: 7 }).map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </Grid>
    );
  }

  return (
    <Grid>
      <KpiCard icon={<Trophy size={ICON_SIZE} />} value={summary.championshipsCount} label="Чемпионатов" />
      <KpiCard icon={<Calendar size={ICON_SIZE} />} value={summary.matchesCount} label="Матчей" />
      <KpiCard icon={<CheckCircle size={ICON_SIZE} />} value={summary.playedMatchesCount} label="Сыгранных матчей" />
      <KpiCard icon={<Users size={ICON_SIZE} />} value={summary.uniqueTeamsCount} label="Уникальных команд" />
      <KpiCard icon={<Target size={ICON_SIZE} />} value={summary.totalGoals} label="Голов забито" />
      <KpiCard icon={<TrendingUp size={ICON_SIZE} />} value={summary.averageGoalsPerMatch} label="Среднее голов за матч" />
      <KpiCard icon={<CalendarDays size={ICON_SIZE} />} value={summary.gameDaysCount} label="Игровых дней" />
    </Grid>
  );
});

export default KpiGrid;
